// jquery-bootstrap.ts -- MUST be imported first in app.ts
// Assigns jQuery to window globals before framework.js checks window.jQuery
import jQuery from 'jquery';

window.jQuery = window.$ = jQuery as any;
